// /Users/pramod/Desktop/school-erp/frontend/src/Tenant-Admin/ManageStaff/Modal.js
import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const Modal = ({ title, children, onClose, size = 'md' }) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  // Handle escape key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && onClose) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  // Clean, premium width boundaries
  const sizeClasses = {
    sm: 'sm:max-w-md',
    md: 'sm:max-w-lg',
    lg: 'sm:max-w-xl',
    xl: 'sm:max-w-3xl',
    full: 'sm:max-w-[94vw]'
  };

  return (
    <div className="fixed inset-0 z-[99999] flex items-end sm:items-center justify-center p-0 sm:p-4 transition-opacity duration-200">
      
      {/* Premium Low-Contrast Dim Backdrop */}
      <div 
        className="absolute inset-0 bg-slate-900/40 backdrop-blur-xs transition-opacity"
        onClick={onClose}
      />
      
      {/* Shell Layout: Mobile Swipe sheet / Desktop Box Card */}
      <div 
        className={`relative ${sizeClasses[size]} w-full bg-white rounded-t-2xl sm:rounded-xl shadow-2xl flex flex-col max-h-[92vh] sm:max-h-[85vh] border border-slate-100 transform transition-all duration-300 ease-out animate-slideUp sm:animate-scaleIn overflow-hidden`}
      >
        
        {/* Mobile Top Drag Sheet Indicator Pillar */}
        <div className="w-full flex justify-center py-2 sm:hidden shrink-0">
          <div className="w-10 h-1 bg-slate-200 rounded-full" />
        </div>

        {/* Dynamic Modal Navigation Title Section */}
        {title && (
          <div className="px-4 pt-1 pb-3 sm:py-4 flex items-center justify-between border-b border-slate-100 shrink-0">
            <h3 className="text-sm font-bold text-slate-900 tracking-tight">{title}</h3>
            {onClose && (
              <button
                onClick={onClose}
                className="p-1 text-slate-400 hover:text-slate-600 rounded-lg transition-colors"
                type="button"
                aria-label="Close dialog"
              >
                <X size={16} />
              </button>
            )}
          </div>
        )}
        
        {/* Standard Content Injected Wrapper Frame Box */}
        <div className="flex-1 overflow-y-auto px-4 py-4 scrollbar-thin">
          {children}
        </div>

      </div>
    </div>
  );
};

export default Modal;